const formatBrPhone = (phone, withAreaCode) => {
  if (withAreaCode) {
    return phone.replace(/([+]\d{2})(\d{2})(\d{4,5})(\d{4})/, '$1 ($2) $3-$4');
  }

  return phone.replace(/(\d{2})(\d{4,5})(\d{4})/, '($1) $2-$3');
};

const localeFormatters = {
  'pt-BR': formatBrPhone,
};

export default localeFormatters;



// WEBPACK FOOTER //
// ../utils/i18n/format-phone.js